// extracted by mini-css-extract-plugin
module.exports = {"card":"open-disputes_card__2aje7","filter":"open-disputes_filter__3e3_l","dropdownContainer":"open-disputes_dropdownContainer__3QFq4"};